import { contents } from ".."
import SkillItem from "../../components/SkillItem"

const VscodeVnwExtension = () => {
    const filteredProjects = contents.filter((item) => item.slug === 'vscode-vietnamworks-extension')
    const project = filteredProjects[0]

    return (
        <div className="overflow-hidden bg-white py-24 sm:py-32 rounded-md">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                    <div className="lg:pr-8 lg:pt-4">
                        <div className="lg:max-w-lg">
                            <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">VietnamWorks Extension for VSCode</h2>
                            <div className="my-4">
                                {project.techStack.map((item, index: number) => {
                                    return (
                                        <SkillItem key={`landl-index-${index}-${item}`} label={item} />
                                    )
                                })}
                            </div>
                            <p className="mt-6 text-lg leading-8 text-gray-600 text-justify">
                                The VietnamWorks VSCode Extension uses the GitLab API to help the team manage merge requests. It has three main features.
                            </p>
                            <p className="mt-6 text-lg leading-8 text-gray-600 text-justify">
                                It shows all merge requests assigned to you.
                                <br /><br />
                                It lets you create merge requests from develop to release across several projects at once.
                                <br /><br />
                                It also lets you create a merge request from your current branch to develop.
                            </p>
                            
                            <p className="mt-6 text-lg leading-8 text-gray-600 text-justify">
                                These shortcuts help the team spend less time creating and finding merge requests.
                            </p>
                            <br />
                            <div>
                                <img
                                    src={require('../../assets/projects/vscode-vietnamworks-extension/screenshot_2.png')}
                                    alt="Create a merge request from the current branch to develop"
                                    className="rounded-xl shadow-xl ring-1 ring-gray-400/10"
                                    width={2432}
                                    height={1442}
                                />
                            </div>
                            <br />
                            
                        </div>
                    </div>
                    <div className="lg:pt-4">
                        <img
                            src={require('../../assets/projects/vscode-vietnamworks-extension/screenshot_1.png')}
                            alt="VietnamWorks VSCode Extension"
                            className="rounded-xl shadow-xl ring-1 ring-gray-400/10"
                            width={2432}
                            height={1442}
                        />
                        <br />
                        <p className="mt-6 text-lg leading-8 text-gray-600 text-justify">
                        I built this extension because the official GitLab extension did not work with our setup.
                        <br /><br />
                        At the time, our company used GitLab 14.10, while the official extension needed version 16.3 or later. I also needed a quick way to find and open merge requests from other developers, since reviewing and merging their code was part of my job.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VscodeVnwExtension
